import React from 'react';

interface LoadingScreenProps {
    message?: string;
    isVisible?: boolean; // Controls fade in/out
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
    message = "Preparing your soundscape...",
    isVisible = true
}) => {
    return (
        <div
            className={`fixed inset-0 bg-black flex flex-col items-center justify-center z-[200] transition-opacity duration-500 ease-out ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}
        >
            {/* Animated Logo/Orb */}
            <div className="relative mb-8">
                {/* Outer glow */}
                <div className="absolute inset-0 w-20 h-20 rounded-full bg-gradient-to-br from-cyan-500/30 to-purple-500/30 blur-xl animate-pulse" />

                {/* Spinning ring */}
                <div className="w-20 h-20 rounded-full border-2 border-transparent border-t-cyan-400 border-r-purple-400 animate-spin"
                    style={{ animationDuration: '1.5s' }} />

                {/* Inner orb */}
                <div className="absolute inset-0 m-auto w-12 h-12 rounded-full bg-gradient-to-br from-cyan-500/20 to-purple-500/20 backdrop-blur-sm animate-pulse"
                    style={{ animationDuration: '2s' }} />
            </div>

            {/* Brand text */}
            <h1 className="text-2xl font-light tracking-[0.3em] text-white/80 mb-4">
                SOLUNN
            </h1>

            {/* Loading message */}
            <p className="text-sm text-white/50 tracking-wide animate-pulse">
                {message}
            </p>

            {/* Subtle progress dots */}
            <div className="flex gap-1.5 mt-6">
                <div className="w-1.5 h-1.5 rounded-full bg-cyan-400/60 animate-bounce" style={{ animationDelay: '0ms' }} />
                <div className="w-1.5 h-1.5 rounded-full bg-purple-400/60 animate-bounce" style={{ animationDelay: '150ms' }} />
                <div className="w-1.5 h-1.5 rounded-full bg-cyan-400/60 animate-bounce" style={{ animationDelay: '300ms' }} />
            </div>
        </div>
    );
};

export default LoadingScreen;
